import {
  ga,
  adrecord,
  awin,
  adtraction,
  adjust,
  remarketing,
  amplitude,
} from 'js/analytics/adapters'
import { baseWebEventProps } from 'js/analytics/standardizedProps'
import { getItem } from 'js/storeManager'
import sha256 from 'js/auth/sha256'

// Options controlling the canonical Amplitude `user_purchase_premium` emit.
// This tracker is the single source of truth for that event (it fires for every
// paid scenario and carries the real transaction data), so the Welcome page and
// the upgrade tracker no longer emit it. `emitAmplitudePremium: false` suppresses
// only the Amplitude premium event (e.g. gift cards) while leaving GA and the
// affiliate conversion pixels intact.
type CompletedPaymentOptions = {
  emitAmplitudePremium?: boolean
  actionName?: 'purchase' | 'upgrade'
  purchaseLifecycle?: 'new' | 'renew'
}

export const trackCompletedPayment = async (
  eventProperties,
  {
    emitAmplitudePremium = true,
    actionName = 'purchase',
    purchaseLifecycle = 'new',
  }: CompletedPaymentOptions = {},
) => {
  const eventCallbackI2hp1x = getItem('event_callback_i2hp1x')
  eventCallbackI2hp1x && fetch(eventCallbackI2hp1x)
  const eventCallbackM2idll = getItem('event_callback_m2idll')
  eventCallbackM2idll && fetch(eventCallbackM2idll)

  const hashedEmail = (await sha256(eventProperties.email)) || ''

  ga.track('purchase', {
    transaction_id: eventProperties.transaction_id,
    currency: eventProperties.currency,
    value: eventProperties.value,
    coupon: eventProperties.coupon,
    account_type: eventProperties.account_type,
    subscription_duration: eventProperties.subscription_duration,
    hashed_email: hashedEmail,
  })
  if (emitAmplitudePremium) {
    amplitude.track('user_purchase_premium', {
      ...baseWebEventProps(),
      action_name: actionName,
      action_type: 'active',
      event_status: 'success',
      purchase_quantity: 1,
      purchase_lifecycle: purchaseLifecycle,
      purchase_type: 'premium subscription',
      purchase_price_local: eventProperties.value,
      purchase_price_currency: eventProperties.currency,
      purchase_product_name: eventProperties.subscription_duration,
      coupon: eventProperties.coupon,
      account_type: eventProperties.account_type,
    })
  }
  adrecord.trackPurchase(eventProperties.value, eventProperties.currency)
  awin.trackPurchase(
    eventProperties.transaction_id,
    eventProperties.coupon,
    eventProperties.value,
    eventProperties.currency,
  )
  adtraction.trackPurchase(
    eventProperties.transaction_id,
    eventProperties.coupon,
    eventProperties.value,
    eventProperties.currency,
  )
  adjust.track(
    'Purchase',
    null,
    eventProperties.value,
    eventProperties.currency,
  )
  remarketing.track(eventProperties.value, eventProperties.currency)
}
